// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ChpdG","requiredAsterisk":"Info_requiredAsterisk__iY_6q"};